import type { FaireProductEntity } from "../../entity_types/product";

export const p_vxv2v4vkc7: FaireProductEntity = {
  token: "p_vxv2v4vkc7",
  type: "product",
  name: "Organic Flowers & Sea Salt Bath Soak",
  brandToken: "b_dw8ijelh",
  brandName: "Lucky Honeybee",
  imageUrl:
    "https://cdn.faire.com/fastly/e93f46ff2d5aaf7d4c3c1d863accd70409d1ed3f974e076bc70da656d9a8ae7a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/896a9bf9c8fb6d7b0ffbb42969c41e2fee105ea100b821aca298b865705166b7.jpeg",
    "https://cdn.faire.com/fastly/fb2c74262d6d51e973f0f07b1156b64fae1fb353964a52ec4bb68230209feb27.jpeg",
    "https://cdn.faire.com/fastly/f13f2d90be02b9b513f982a30e358b75bb7fe56bcf7c9d75054299519b5aee03.jpeg",
    "https://cdn.faire.com/fastly/3c0c6c6714565435f278a479399e36fc61d288f7ababb8a734d0e6c91943ce3e.jpeg",
  ],
  priceDollars: 11.64,
  description:
    "LHB bath soaks are formulated with Pink Himalayan Sea Salt, Dead Sea Salt, and Organic flowers.\n\nOur salt blend utilizes both Pink Himalayan and Dead Sea Salts which are composed of over 84 minerals and trace elements. These are said help aid in maintaining the skin's moisture, to stimulate circulation, relax the body, soothe sore muscles, and help draw toxins from the body.\n\nBlended with your choice of red rose petals, known to help hydrate and soften the skin, lavender buds known for it's a calming properties, or eucalyptus mint for sore muscles.",
  tags: [],
  msrpDollars: 23.29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:52.148Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
